<ng-container>
  <!-- Table -->
  <span class="small text-danger" *ngIf="columnRowSelection">*Double click/tap to view page.</span>

  <table mat-table [dataSource]="tableDataSource" matSort matSortDisableClear class="mat-elevation-z0">
    <ng-container matColumnDef="sn">
      <th mat-header-cell *matHeaderCellDef>#</th>
      <td mat-cell *matCellDef="let element; let i = index">
        {{ getPagingIndex(i) }}
      </td>
    </ng-container>

    <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.name">
      <ng-container *ngIf="tableColumn.isAction && tableColumn.actionData.length > 0">
        <th mat-header-cell *matHeaderCellDef>{{ tableColumn.name.toUpperCase() }}</th>
        <td mat-cell *matCellDef="let element" >
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            matTooltip="More actions"
            (click)="$event.stopPropagation()">
            <i class="bi bi-three-dots-vertical"></i>
          </button>

          <mat-menu #menu="matMenu">

            <button
                    *ngFor="let action of tableColumn.actionData"
                    mat-menu-item
                    type="button"
                    (click)="emitParentTableAction(element.id, action.type)">
              <i [class]="action.icon"></i>

              <span class="ml-3">{{ action.name }}</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <!-- if sortable column header -->
      <ng-container *ngIf="tableColumn.isSortable; else notSortable">
        <th
          mat-header-cell
          [style.width]="tableColumn.width"
          *matHeaderCellDef
          [mat-sort-header]="tableColumn.name"
          [arrowPosition]="tableColumn.position === 'right' ? 'before' : 'after'">
          {{ tableColumn.name.toUpperCase() }}
        </th>
      </ng-container>
      <!-- else not sortable -->
      <ng-template #notSortable>
        <th mat-header-cell
            [style.width]="tableColumn.width"
            *matHeaderCellDef [class.text-right]="tableColumn.position == 'right'">
          {{ tableColumn.name.toUpperCase() }}
        </th>
      </ng-template>

      <!-- column data -->
      <td mat-cell *matCellDef="let element" [class.text-right]="tableColumn.position == 'right'">
        <div [innerHTML]="sanitizeHtml(element | dataPropertyGetter : tableColumn)"></div>
      </td>
    </ng-container>

    <ng-container matColumnDef="lastUpdate">
      <th mat-header-cell *matHeaderCellDef [class.text-right]="true">LAST UPDATED</th>
      <td mat-cell *matCellDef="let element; let i = index" [class.text-right]="true">
        <div [innerHTML]="getLastUpdate(element)"></div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
<!--    <tr-->
<!--      mat-row-->
<!--      *matRowDef="let element; columns: displayedColumns"-->
<!--      [class.hidden]="!columnRowSelection && !columnRowSelection.routerLink"-->
<!--      [routerLink]="columnRowSelection.routerLink"-->
<!--      [queryParams]="{id: element.id, type: columnRowSelection.type}"></tr>-->

    <tr
      mat-row
      *matRowDef="let element; columns: displayedColumns"
      [class.hidden]="!columnRowSelection && !columnRowSelection.routerLink"
      class="example-element-row"
      (dblclick)="openPage(columnRowSelection.routerLink, {id: element.id, type: columnRowSelection.type})"></tr>

  </table>
  <div class="text-center mt-2 mb-2 text-muted" *ngIf="tableDataSource.data.length <= 0">No records found</div>
  <!-- Pagination -->
  <mat-paginator
    *ngIf="isPageable"
    [pageSizeOptions]="paginationSizes"
    [pageSize]="pageSize"
    [length]="totalRow"
    (page)="handlePageEvent($event)"
    showFirstLastButtons>
  </mat-paginator>
</ng-container>
